import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import {
  GetStationsConnectionsFilter,
  StationFilter,
  StationFilterFormatted,
  StationIssueFilter,
  StationViewRawDataFilter,
} from "@shared/interfaces";

import { ActivateDeactivateStationDto, CreateStationDto } from "../interfaces";

export default {
  getStations: (payload: StationFilter) => {
    const { hospital, search, ...restParams } = payload;

    const params: StationFilterFormatted = {
      ...restParams,
      search: search?.trim(),
    };

    if (hospital) {
      params.hospital_id = Number(hospital.value);
    }

    return request(METHODS.GET, API.STATION.GET_STATIONS)({ params });
  },
  createStation: (payload: CreateStationDto) => request(METHODS.POST, API.STATION.CREATE_STATION)(payload),
  activateDeactivateStation: (id: number, payload: ActivateDeactivateStationDto) => {
    return request(METHODS.POST, API.STATION.ACTIVATE_DEACTIVATE_STATION(String(id)))(payload);
  },
  updateStation: (payload: CreateStationDto & { id: number }) => {
    const { id, ...rest } = payload;
    return request(METHODS.PUT, API.STATION.UPDATE_STATION(String(id)))(rest);
  },
  getStationRawData: (id: string, query: StationViewRawDataFilter) =>
    request(METHODS.GET, API.STATION.GET_STATION_RAW_DATA(id))({ params: query }),
  loadStationIssues: (query: StationIssueFilter) =>
    request(METHODS.GET, API.STATION.GET_STATIONS_ISSUES)({ params: query }),
  getStationsConnections: (query: GetStationsConnectionsFilter) =>
    request(METHODS.GET, API.STATION.GET_STATIONS_CONNECTIONS)({ params: query }),
  readStationIssue: (id: string, comment: string) =>
    request(METHODS.POST, API.STATION.READ_STATION_ISSUE(id))({ comment }),
};
